import Splide from "@splidejs/splide";
import EmblaCarousel from 'embla-carousel';

export function initImageSliders(container)
{
    let allReviewImages = container.querySelectorAll('.canvas-review-images');
    allReviewImages.forEach(function(slider) {
        new Splide(slider, {
            type: 'slide',
            autoWidth: true,
            pagination: false,
            lazyLoad: 'sequential',
            focus: 0,
            omitEnd: true,
        }).mount();
    });
}

export function initEmblaImageSliders(container)
{
    container.querySelectorAll('.canvas-review-images:not(.embla-initialized)').forEach(function(reviewCarousel) {
        const slider = reviewCarousel.querySelector('.embla-carousel');
        if (!slider) {
            return;
        }

        const prevButton = reviewCarousel.querySelector('.embla-prev-button');
        const nextButton = reviewCarousel.querySelector('.embla-next-button');

        const embla = EmblaCarousel(slider, {
            align: 'start',
            containScroll: 'trimSnaps',
            dragFree: true,
        });

        const updateButtons = function() {
            if (prevButton) {
                prevButton.disabled = !embla.canScrollPrev();
            }
            if (nextButton) {
                nextButton.disabled = !embla.canScrollNext();
            }
        };

        if (prevButton) {
            prevButton.addEventListener('click', function() {
                embla.scrollPrev();
            });
        }
        if (nextButton) {
            nextButton.addEventListener('click', function() {
                embla.scrollNext();
            });
        }

        embla.on('init', updateButtons);
        embla.on('select', updateButtons);
        embla.on('reInit', updateButtons);

        reviewCarousel.classList.add('embla-initialized');
        embla.reInit();
    });
}